import { number, shape, string } from 'prop-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { SHAPE } from '../../../../common';
import { Uri } from '../../../../components';
import { Consumer } from '../../../../context';
import { LAYOUT } from '../../../../reactor/common';
import { Button, Image, Text } from '../../../../reactor/components';
import styles from './Footer.style';

const Footer = ({
  image, link, title, subtitle, visibility, ...inherit
}) => {
  const { PORTRAIT } = LAYOUT.VIEWPORT;

  return (
    <View style={styles.container}>
      { image
        && <Image resizeMode="contain" source={{ uri: image }} style={styles.image} /> }
      { title
        && (
        <Text
          headline
          level={PORTRAIT ? 4 : 2}
          color={inherit.color}
          style={StyleSheet.flatten([styles.text, styles.title])}
        >
          {title}
        </Text>
        )}
      { subtitle && (
      <Text color={inherit.color} style={styles.text}>
        {subtitle}
      </Text>
      ) }
      { link && (
        <Uri eventProps={{ target: link.uri }} target="_blank" to={link.uri} style={styles.button}>
          <Consumer>
            { ({ dataSource: { primary } = {} }) => <Button {...link} color={link.color || primary} />}
          </Consumer>
        </Uri>)}
    </View>
  );
};

Footer.propTypes = {
  image: string,
  link: shape(SHAPE.LINK),
  title: string.isRequired,
  subtitle: string,
  visibility: number.isRequired,
};

Footer.defaultProps = {
  image: undefined,
  link: undefined,
  subtitle: undefined,
};

export default Footer;
